module.exports = __webpack_public_path__ + "static/media/icon_mic.89dc2e9d.svg";